import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

/**
 * When Refi is selected and there are more than one car, ask which car to loan.
 */
export const RefiCarsBeforeOnboardingStep: Step = {
  id: 'askRefiCars',
  pathname: '/reficars',
  excludeFromProgressCalculation: true,
  canShow: (appData) => {
    return (
      !!appData.selectedService?.refi &&
      // If Insurance is selected, ask this question during onboarding.
      !appData.selectedService.insurance &&
      !!appData.selectedCars &&
      appData.selectedCars.length > 1
    );
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Cars,
};
